/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/nlp-integration-api-client";
import type { QueryTopicsLiveTopicsQueryResponse, QueryTopicsLiveTopicsPathParams, QueryTopicsLiveTopicsQueryParams } from "../models/QueryTopicsLiveTopics";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { queryTopicsLiveTopics } from "../axios/queryTopicsLiveTopics";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const queryTopicsLiveTopicsQueryKey = (slug: QueryTopicsLiveTopicsPathParams["slug"], params: QueryTopicsLiveTopicsQueryParams = {}) => ["nlp-integration-api", { url: '/live-topics/:slug/topics', params: {slug:slug} }, ...(params ? [params] : [])] as const

export type QueryTopicsLiveTopicsQueryKey = ReturnType<typeof queryTopicsLiveTopicsQueryKey>

export function queryTopicsLiveTopicsQueryOptions(slug: QueryTopicsLiveTopicsPathParams["slug"], params?: QueryTopicsLiveTopicsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = queryTopicsLiveTopicsQueryKey(slug, params)
        return queryOptions<QueryTopicsLiveTopicsQueryResponse, ResponseErrorConfig<Error>, QueryTopicsLiveTopicsQueryResponse, typeof queryKey>({
         enabled: !!(slug),
         queryKey,
         queryFn: async ({ signal }) => {
            return queryTopicsLiveTopics(slug, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Query topics by start time for timeline views.
 * @summary Query topics by time range
 * {@link /live-topics/:slug/topics}
 */
export function useQueryTopicsLiveTopics<TData = QueryTopicsLiveTopicsQueryResponse, TQueryData = QueryTopicsLiveTopicsQueryResponse, TQueryKey extends QueryKey = QueryTopicsLiveTopicsQueryKey>(slug: QueryTopicsLiveTopicsPathParams["slug"], params?: QueryTopicsLiveTopicsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<QueryTopicsLiveTopicsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? queryTopicsLiveTopicsQueryKey(slug, params)
         

         const query = useQuery({
          ...queryTopicsLiveTopicsQueryOptions(slug, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}